import { URLS } from '../../../constants';
import apiClient from '../../client';

const getSessionNoteSignedByCredentialsApi = {
  getSessionNoteSignedByCredentials: () =>
    apiClient.post(URLS.getSessionNoteSignedByCredentials, {
      data: {},
    }),
  getCredentialsById: (primaryUser: any) =>
    apiClient.post(URLS.getCredentialsById, {
      data: {
        primaryUser,
      },
    }),
};

export default getSessionNoteSignedByCredentialsApi;
